import React from 'react';
import './Style.css';

const Home = () => {
  return (
    <div style={{ overflowX: 'hidden' }}>
      <div style={{ position: 'relative', width: '100%', height: '70vh' }}>
          <img
            src="/image/bg4.jpg" alt="Hotel" className="img-fluid" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          
          {/* Black semi-transparent overlay */}
          <div style={{
            position: 'absolute',
            top: 0, left: 0,
            width: '100%', height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // 0.4 মানে হালকা কালো
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            fontSize: '3rem',
            fontWeight: 'bold'
          }}>
             Home
          </div>
        </div>
      
      {/* Hero Section */}
      <section
        className="py-5 hero-full heroClass"
        style={{ minHeight: '110vh', display: 'flex', alignItems: 'center', }} >
        <div className="container">
          <div className="row align-items-center">
            {/* Text Part */}
            <div className="col-12 col-md-6" style={{ textAlign: 'left', paddingRight: '30px' }}>
              <h4 style={{ fontSize: '1.2rem' }}>☆☆☆☆☆ 1000+ happy clients</h4>
              <h1 className="display-1 my-4">
                <strong>Best Luxury hotel in the world.</strong>
              </h1>
              <p>
                Discover the ultimate comfort and luxury with our handpicked selection of hotels
                designed to make your stay unforgettable.
              </p>
              <button className="btn btn-secondary m-2 p-3">ABOUT MORE</button>
            </div>

            {/* Image Part===================== */}
            <div className="col-12 col-md-6 p-0">
              <img
                src="/image/bg4.jpg"
                className="img-fluid w-100"
                style={{ maxHeight: '100%', objectFit: 'cover' }}
                alt="Hotel"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Second Section ================== */}

    <section className="py-5 " style={{ backgroundColor: '#f8f9fa', marginBottom: "100px" }}>
  <div className="container">
    {/* Flex container with wrapping */}
    <div className="d-flex flex-wrap justify-content-between align-items-center gap-4">

      {/* Text Div */}
      <div style={{ flex: '1 1 22%', minWidth: '250px' }} className="text-center text-md-start">
        <h4>HOTELER HOTEL</h4>
        <h1 className="display-6 my-4"><strong>Your Ideal Stay Our Priority</strong></h1>
        <p>Hoteler in a powerful way of just not an only profession, however, a passion for our company.</p>
        <button className="btn btn-secondary mt-3 p-2 px-4">CONTACT US</button>
      </div>

      {/* Image 1 */}
      <div style={{ flex: '1 1 22%', minWidth: '200px' }}>
        <img src="/image/service11.jpg" className="img-fluid rounded" alt="Service 1" />
      </div>

      {/* Image 2 */}
      <div style={{ flex: '1 1 22%', minWidth: '200px' }}>
        <img src="/image/service12.jpg" className="img-fluid rounded" alt="Service 2" />
      </div>

      {/* Image 3 */}
      <div style={{ flex: '1 1 22%', minWidth: '200px' }}>
        <img src="/image/service13.jpg" className="img-fluid rounded" alt="Service 3" />
      </div>

    </div>
  </div>
</section>


<div 
style={{ backgroundColor: 'black', color: "white"  }} >
   <div className="container">
          <div className="row align-items-center">
              {/* Image Part */}
            <div className="col-12 col-md-6  pb-5">
              <img src="/image/slider5.jpg" className="img-fluid w-100" style={{ maxHeight: '100%', objectFit: 'cover' }} alt="Hotel" />
              <div className='pt-4'>
                <p  >Extraordinary HOTEL</p>
                <h1 className="display-5 my-4"><strong>Your Gateway to Unforgettable Stays</strong></h1>
              </div>
            </div>
            {/* Text Part */}
            <div className="col-12 col-md-6 " >
              <h4 style={{ fontSize: '1.1rem'}} >ABOUT HOTELER</h4>
              <h1 className="display-5 my-4"><strong>Discover Comfort in Every Booking</strong></h1>
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots </p>
            </div>

          
          </div>
        </div>
</div>

<section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
  <div className="container">
 
    <div className="d-flex flex-wrap justify-content-between gap-3">

      {/* Image 1 */}
      <div style={{ flex: '1 1 30%' }}>
        <img
          src="/image/service11.jpg"
          className="img-fluid rounded w-100"
          style={{ height: '400px', objectFit: 'cover' }}
          alt="Service 1"
        />
      </div>

      {/* Image 2 */}
      <div style={{ flex: '1 1 30%' }}>
        <img
          src="/image/service12.jpg"
          className="img-fluid rounded w-100"
          style={{ height: '400px', objectFit: 'cover' }}
          alt="Service 2"
        />
      </div>

      {/* Image 3 */}
      <div style={{ flex: '1 1 30%' }}>
        <img
          src="/image/service13.jpg"
          className="img-fluid rounded w-100"
          style={{ height: '400px', objectFit: 'cover' }}
          alt="Service 3"
        />
      </div>

    </div>
  </div>
</section>





    </div>
  );
};

export default Home;
